import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Translation files
import en from "./constants/locales/en.json";
import nl from "./constants/locales/nl.json";
import se from "./constants/locales/se.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    nl: { translation: nl },
    se: { translation: se },
  },
  lng: "en", // Default language
  fallbackLng: "en", // Fallback language if translation is missing
  interpolation: {
    escapeValue: false, // React already escapes variables
  },
});

export default i18n;
